import { useCallback } from 'react';

import * as server from '../../../server';
import { useDynamicReducerDispatch } from '../../../store';
import * as actions from '../../../store/actions';

export const usePlayerData = () => {
    const dynamicReducerDispatch = useDynamicReducerDispatch();

    return useCallback(async () => {
        const response = await server.getPlayerInfo({
            requestedPlayerData: [
                3, // address
                4, // birthdate
                7, // city
                8, // countryCode
                19, // email
                21, // firstname
                24, // lastname
                29, // state
                34 // zip
            ]
        });
        const {
            address,
            birthDate,
            city,
            countryCode,
            email,
            firstName,
            lastName,
            state,
            zip
        } = response.data;

        dynamicReducerDispatch(actions.setPlayerData({
            address,
            birthDate,
            city,
            countryCode,
            email,
            firstName,
            lastName,
            state,
            zip
        }));
    }, [
        dynamicReducerDispatch
    ]);
};
